import React from 'react';

const linkStyle = {
    color: '#4A90E2',
    textDecoration: 'underline',
};

const eksAdGroupRequestUrl = 'https://devx-infra.mypepsico.com/access-management-myidm/DAY2ADDMEMBERS';
const sqlServiceAccountRequestUrl = 'https://devx-infra.mypepsico.com/service-account-creation/DAY2SERVICEACCOUNT';
const awsAccInfo =
    'To proceed with AWS Account Onboarding, a pre-requisite is to have a valid AWS Cloud Onboarding Order ID. This ensures that your architecture has been approved for RI003 before we proceed. Please provide your Cloud Onboarding Order ID for validation.';

const eksInfo = (
    <>
        To onboard an EKS Namespace, please select your Department and Program. This will help us identify the correct AWS EKS Cluster for your application. You
        will also need an Active Directory Group matching the pattern <strong>Team.App.AWS.EKS.*</strong>. If you don&apos;t have one, request it{' '}
        <a href={eksAdGroupRequestUrl} target="_blank" rel="noreferrer" style={linkStyle}>
            here
        </a>{' '}
        and return once the order is complete to select it. AD group creation for EKS will be available in this workflow soon.
    </>
);

const sqlInfo = (
    <>
        Please provide your Database Name, Domain, and Service Account to proceed with AWS SQL RDS database provisioning. If you do not have an SQL Service
        Account, request it{' '}
        <a href={sqlServiceAccountRequestUrl} target="_blank" rel="noreferrer" style={linkStyle}>
            here
        </a>
        , then return and select it to continue with your order.
    </>
);

const rdsInfo = 'Please provide your Database Name to proceed with RDS provisioning. By default, the latest available AWS RDS version will be used.';

const snsInfo = 'Please select the subscription type to associate with your SNS Topic onboarding.';

const redisInfo = (
    <>
        Please select a deployment type to proceed with Redis Cache provisioning. We currently support both <strong>Serverless</strong> and{' '}
        <strong>Cluster</strong> deployment types.
    </>
);

// Maps a resource's configurationComponentCode to the tooltip content shown beside the drawer title.
const titleInfoByCode = {
    AWSACC: awsAccInfo,
    EKSNS: eksInfo,
    SQL: sqlInfo,
    POSTGRESQL: rdsInfo,
    MYSQL: rdsInfo,
    ORACLE: rdsInfo,
    SNS: snsInfo,
    REDIS: redisInfo,
};

export const getConfigTitleInfo = (configurationComponentCode) => titleInfoByCode[configurationComponentCode] || null;

export default getConfigTitleInfo;
